import { useEffect, useRef } from 'react';

const HeroSection = () => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    setTimeout(() => el.classList.add('opacity-100', 'translate-y-0'), 100);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=modern%20industrial%20factory%20building%20with%20corrugated%20metal%20sandwich%20panel%20roof%20aerial%20view%20dramatic%20sky%20professional%20architectural%20photography%20premium%20construction%20site%20dark%20navy%20atmosphere&width=1920&height=1080&seq=hero001&orientation=landscape"
          alt="산업 건물 지붕"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1B2A4A]/90 via-[#1B2A4A]/70 to-[#1B2A4A]/40" />
      </div>

      <div className="relative w-full max-w-7xl mx-auto px-6 lg:px-8 pt-24 pb-16 flex flex-col lg:flex-row items-center gap-12">
        <div
          ref={ref}
          className="flex-1 opacity-0 translate-y-8 transition-all duration-700 ease-out"
        >
          <div className="inline-flex items-center gap-2 bg-[#FF6B35]/20 border border-[#FF6B35]/40 px-4 py-1.5 rounded-full mb-6">
            <span className="w-2 h-2 rounded-full bg-[#FF6B35] animate-pulse" />
            <span className="text-[#FF6B35] text-xs font-semibold tracking-widest uppercase">특허 출원 완료 · 10-2024-0173136</span>
          </div>

          <h1 className="font-display text-5xl lg:text-6xl xl:text-7xl font-bold text-white leading-tight mb-4">
            Smart<span className="text-[#FF6B35]">Cap</span>
          </h1>
          <p className="text-2xl lg:text-3xl font-light text-white/90 mb-3">스마트캡</p>
          <p className="text-xl lg:text-2xl text-[#FF6B35] font-medium mb-6">
            "방수도 시공도 한 번에"
          </p>
          <p className="text-white/75 text-base lg:text-lg leading-relaxed max-w-lg mb-10">
            실리콘 패킹 일체형 지붕 마감캡. 샌드위치패널 지붕 시공 시<br />
            누수를 자동으로 차단하는 신개념 방수 마감캡 솔루션.
          </p>

          <div className="flex flex-wrap gap-4">
            <button
              onClick={() => scrollTo('solution')}
              className="bg-white text-[#1B2A4A] font-semibold px-8 py-3.5 rounded-md hover:bg-[#FF6B35] hover:text-white transition-all duration-250 cursor-pointer whitespace-nowrap"
            >
              제품 알아보기
            </button>
            <button
              onClick={() => scrollTo('cta')}
              className="border-2 border-[#FF6B35] text-[#FF6B35] font-semibold px-8 py-3.5 rounded-md hover:bg-[#FF6B35] hover:text-white transition-all duration-250 cursor-pointer whitespace-nowrap"
            >
              견적 문의
            </button>
          </div>
        </div>

        <div className="flex-1 flex justify-center lg:justify-end">
          <div className="relative">
            <div className="absolute -inset-4 bg-[#FF6B35]/20 rounded-2xl blur-2xl" />
            <div className="relative bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-6 max-w-sm">
              <img
                src="https://storage.readdy-site.link/project_files/a91d34d6-979b-40c4-a28b-dffad304fbfe/e887b210-812b-4abe-bc08-5d1f4401ce40_1-Photoroom-.png?v=a021eaecc99655c9822a066d80b409b5"
                alt="스마트캡 제품"
                className="w-full h-72 object-contain drop-shadow-2xl"
              />
              <div className="mt-4 flex gap-3">
                <div className="flex-1 bg-white/10 rounded-lg p-3 text-center">
                  <p className="text-[#FF6B35] font-bold text-lg">100%</p>
                  <p className="text-white/70 text-xs mt-0.5">방수 효과</p>
                </div>
                <div className="flex-1 bg-white/10 rounded-lg p-3 text-center">
                  <p className="text-[#FF6B35] font-bold text-lg">50%</p>
                  <p className="text-white/70 text-xs mt-0.5">시공 시간 단축</p>
                </div>
                <div className="flex-1 bg-white/10 rounded-lg p-3 text-center">
                  <p className="text-[#FF6B35] font-bold text-lg">특허</p>
                  <p className="text-white/70 text-xs mt-0.5">출원 완료</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 animate-bounce">
        <span className="text-white/50 text-xs tracking-widest uppercase">Scroll</span>
        <i className="ri-arrow-down-line text-white/50 text-lg" />
      </div>
    </section>
  );
};

export default HeroSection;
